import { inject, Pipe, PipeTransform } from '@angular/core';
import { StaticContentService } from '@mwe/services';

@Pipe({ name: 'addStaticImagePath' })
export class AddStaticImagePathPipe implements PipeTransform {
  private readonly staticContentService = inject(StaticContentService);

  transform(fileName: string): string {
    return `${this.staticContentService.getImagePath()}${fileName}`;
  }
}
